import dayjs from "dayjs";

// 判断单个条件是否成立
function evaluateCondition({ field, operator, value }, allFieldValues) {
    const item = allFieldValues[field];

    if (!item || !('value' in item) || !('type' in item)) return false;

    const fieldValue = item.value;
    const fieldType = item.type;

    const isEmpty = val =>
        val === undefined ||
        val === null ||
        val === '' ||
        (Array.isArray(val) && val.length === 0);
    
    const parseDate = val => dayjs(val);
    const isDateComponent = ['DatePicker', 'TimePicker'].includes(fieldType);

    function isValidNumber(val) {
        return typeof val === 'number' || (!isNaN(val) && val !== null && val !== '');
    }

    switch (operator) {
        case 'empty':
            return isEmpty(fieldValue);
        case 'noEmpty':
            return !isEmpty(fieldValue);
        case '=':
            if (isDateComponent && fieldValue && !(Array.isArray(fieldValue))) return parseDate(fieldValue).isSame(parseDate(value));
            return fieldValue === value;
        case '!=':
            if (isDateComponent && fieldValue && !(Array.isArray(fieldValue))) return !parseDate(fieldValue).isSame(parseDate(value));
            return fieldValue !== value;
        case '{}':
            return typeof fieldValue === 'string' && fieldValue.includes(value);
        case '!{}':
            return typeof fieldValue === 'string' && !fieldValue.includes(value);
        case '>':
            if (isDateComponent && fieldValue && !(Array.isArray(fieldValue))) return parseDate(fieldValue).isAfter(parseDate(value));
            else if (isDateComponent && fieldValue && (Array.isArray(fieldValue))) {
                const [start, end] = fieldValue.map(parseDate);
                const target = parseDate(value);
                return start.isAfter(target)
            }
            const numA = parseFloat(fieldValue);
            const numB = parseFloat(value);
            if (isNaN(numA) || isNaN(numB)) return false;
            return numA > numB;
        case '<':
            if (isDateComponent && fieldValue && !(Array.isArray(fieldValue))) return parseDate(fieldValue).isBefore(parseDate(value));
            else if (isDateComponent && fieldValue && (Array.isArray(fieldValue))) {
                const [start, end] = fieldValue.map(parseDate);
                const target = parseDate(value);
                return end.isBefore(target)
            }
            const numA2 = parseFloat(fieldValue);
            const numB2 = parseFloat(value);
            if (isNaN(numA2) || isNaN(numB2)) return false;
            return numA2 < numB2;
        case '>=':
            if (isDateComponent && fieldValue && !(Array.isArray(fieldValue))) return parseDate(fieldValue).isSame(parseDate(value)) || parseDate(fieldValue).isAfter(parseDate(value));
            else if (isDateComponent && fieldValue && (Array.isArray(fieldValue))) {
                const [start, end] = fieldValue.map(parseDate);
                const target = parseDate(value);
                return start.isSame(target) || start.isAfter(target)
            }
            const numA3 = parseFloat(fieldValue);
            const numB3 = parseFloat(value);
            if (isNaN(numA3) || isNaN(numB3)) return false;
            return numA3 > numB3;
        case '<=':
            if (isDateComponent && fieldValue && !(Array.isArray(fieldValue))) return parseDate(fieldValue).isSame(parseDate(value)) || parseDate(fieldValue).isBefore(parseDate(value));
            else if (isDateComponent && fieldValue && (Array.isArray(fieldValue))) {
                const [start, end] = fieldValue.map(parseDate);
                const target = parseDate(value);
                return end.isSame(target) || end.isBefore(target)
            }
            const numA4 = parseFloat(fieldValue);
            const numB4 = parseFloat(value);
            if (isNaN(numA4) || isNaN(numB4)) return false;
            return numA4 > numB4;
        case 'includes':
            return Array.isArray(fieldValue) && fieldValue.includes(value);
        case 'all':
            return Array.isArray(value) && value.every(v => fieldValue.includes(v));
        default:
            return false;
    }
}

// 计算所有条件的最终结果（是否可见）
export function shouldComponentBeVisible(conditions = [], allFieldValues) {
    if (!conditions.length) return false;

    // 初始值为第一个条件
    let result = evaluateCondition(conditions[0], allFieldValues);
    for (let i = 1; i < conditions.length; i++) {
        const condition = conditions[i];
        const currentResult = evaluateCondition(condition, allFieldValues);
        if (condition.logic === 'and') {
            result = result && currentResult;
        } else if (condition.logic === 'or') {
            result = result || currentResult;
        }
    }

    return result;
}